import { ElementType, LayoutElement } from '../../../types/models/Elements';

export const landscapeLayouts2Photo: LayoutElement[][] = [
  [
    {
      type: ElementType.BLOCK,
      width: 1,
      height: 1,
      top: 0,
      left: 0,
      style: {
        gap: 50,
        direction: 'row',
      },
      children: [
        {
          type: ElementType.PHOTO,
          width: 0.5,
          height: 1,
          top: 0,
          left: 0,
        },
        {
          type: ElementType.PHOTO,
          width: 0.5,
          height: 1,
          top: 0,
          left: 0,
        },
      ],
    },
  ],
  [
    {
      type: ElementType.BLOCK,
      width: 0.82,
      height: 0.74,
      top: 0.13,
      left: 0.09,
      style: {
        gap: 50,
        direction: 'row',
      },
      children: [
        {
          type: ElementType.PHOTO,
          width: 0.5,
          height: 1,
          top: 0,
          left: 0,
        },
        {
          type: ElementType.PHOTO,
          width: 0.5,
          height: 1,
          top: 0,
          left: 0,
        },
      ],
    },
  ],
  [
    {
      type: ElementType.BLOCK,
      width: 1,
      height: 1,
      top: 0,
      left: 0,
      style: {
        gap: 50,
        direction: 'row',
      },
      children: [
        {
          type: ElementType.PHOTO,
          width: 2 / 3,
          height: 1,
          top: 0,
          left: 0,
        },
        {
          type: ElementType.PHOTO,
          width: 1 / 3,
          height: 1,
          top: 0,
          left: 0,
        },
      ],
    },
  ],
  [
    {
      type: ElementType.BLOCK,
      width: 0.82,
      height: 0.74,
      top: 0.13,
      left: 0.09,
      style: {
        gap: 50,
        direction: 'row',
      },
      children: [
        {
          type: ElementType.PHOTO,
          width: 2 / 3,
          height: 1,
          top: 0,
          left: 0,
        },
        {
          type: ElementType.PHOTO,
          width: 1 / 3,
          height: 1,
          top: 0,
          left: 0,
        },
      ],
    },
  ],
  [
    {
      type: ElementType.BLOCK,
      width: 0.82,
      height: 0.6,
      top: 0.2,
      left: 0.09,
      style: {
        gap: 50,
        direction: 'row',
      },
      children: [
        {
          type: ElementType.PHOTO,
          width: 0.5,
          height: 1,
          top: 0,
          left: 0,
        },
        {
          type: ElementType.PHOTO,
          width: 0.5,
          height: 1,
          top: 0,
          left: 0,
        },
      ],
    },
    {
      type: ElementType.TEXT,
      width: 0.52,
      height: 0.09,
      top: 0.84,
      left: 0.24,
    },
  ],
  [
    {
      type: ElementType.BLOCK,
      width: 0.56,
      height: 0.41,
      top: 0.3,
      left: 0.22,
      style: {
        gap: 50,
        direction: 'row',
      },
      children: [
        {
          type: ElementType.PHOTO,
          width: 0.5,
          height: 1,
          top: 0,
          left: 0,
        },
        {
          type: ElementType.PHOTO,
          width: 0.5,
          height: 1,
          top: 0,
          left: 0,
        },
      ],
    },
    {
      type: ElementType.TEXT,
      width: 0.52,
      height: 0.09,
      top: 0.76,
      left: 0.24,
    },
  ],
  [
    {
      type: ElementType.BLOCK,
      width: 0.82,
      height: 0.46,
      top: 0.27,
      left: 0.09,
      style: {
        gap: 50,
        direction: 'row',
      },
      children: [
        {
          type: ElementType.PHOTO,
          width: 0.5,
          height: 1,
          top: 0,
          left: 0,
        },
        {
          type: ElementType.PHOTO,
          width: 0.5,
          height: 1,
          top: 0,
          left: 0,
        },
      ],
    },
    {
      type: ElementType.TEXT,
      width: 0.52,
      height: 0.09,
      top: 0.77,
      left: 0.24,
    },
  ],
  [
    {
      type: ElementType.BLOCK,
      width: 0.3,
      height: 0.68,
      top: 0.16,
      left: 0.35,
      style: {
        gap: 50,
        direction: 'column',
      },
      children: [
        {
          type: ElementType.PHOTO,
          width: 1,
          height: 0.5,
          top: 0,
          left: 0,
        },
        {
          type: ElementType.PHOTO,
          width: 1,
          height: 0.5,
          top: 0,
          left: 0,
        },
      ],
    },
  ],
  [
    {
      type: ElementType.BLOCK,
      width: 0.56,
      height: 0.7,
      top: 0.15,
      left: 0.22,
      style: {
        gap: 50,
        direction: 'column',
      },
      children: [
        {
          type: ElementType.BLOCK,
          width: 1,
          height: 0.5,
          top: 0,
          left: 0,
          style: {
            gap: 50,
            direction: 'row',
          },
          children: [
            {
              type: ElementType.PHOTO,
              width: 0.55,
              height: 1,
              top: 0,
              left: 0,
            },
            {
              type: ElementType.TEXT,
              width: 0.45,
              height: 0.8,
              top: 0.1,
              left: 0,
            },
          ],
        },
        {
          type: ElementType.BLOCK,
          width: 1,
          height: 0.5,
          top: 0,
          left: 0,
          style: {
            gap: 50,
            direction: 'row',
          },
          children: [
            {
              type: ElementType.PHOTO,
              width: 0.55,
              height: 1,
              top: 0,
              left: 0,
            },
            {
              type: ElementType.TEXT,
              width: 0.45,
              height: 0.8,
              top: 0.1,
              left: 0,
            },
          ],
        },
      ],
    },
  ],
  [
    {
      type: ElementType.BLOCK,
      width: 0.7,
      height: 0.86,
      top: 0.08,
      left: 0.15,
      style: {
        gap: 50,
        direction: 'column',
      },
      children: [
        {
          type: ElementType.BLOCK,
          width: 1,
          height: 0.5,
          top: 0,
          left: 0,
          style: {
            gap: 50,
            direction: 'row',
          },
          children: [
            {
              type: ElementType.TEXT,
              width: 0.25,
              height: 1,
              top: 0,
              left: 0,
            },
            {
              type: ElementType.PHOTO,
              width: 0.75,
              height: 1,
              top: 0,
              left: 0,
            },
          ],
        },
        {
          type: ElementType.BLOCK,
          width: 1,
          height: 0.5,
          top: 0,
          left: 0,
          style: {
            gap: 50,
            direction: 'row',
          },
          children: [
            {
              type: ElementType.PHOTO,
              width: 0.75,
              height: 1,
              top: 0,
              left: 0,
            },
            {
              type: ElementType.TEXT,
              width: 0.25,
              height: 1,
              top: 0,
              left: 0,
            },
          ],
        },
      ],
    },
  ],
];
